import React, { useRef, useState } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { Offset, Popup } from '@progress/kendo-react-popup';
import { MenuProps } from './ChatOptions';
import { Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout';
import { IChat } from '../types/IChat';
import { ChatApi } from '../redux/api/ChatApi';
import { useReduxDispatch } from '../redux/hooks';
import { CloseChat, LeaveChat, MarkAsRead } from '../redux/reducers/ChatSlice';
import { ChatIsUnRead } from '../util/ChatUtils';
import { IUserProfile } from '../types/IUserProfile';

export default function ChatMenu({ chat, profile }: { chat: IChat, profile: IUserProfile }) {
    const dispatch = useReduxDispatch();
    const [menu, setMenu] = useState<MenuProps>({} as MenuProps)
    const [closeChat] = ChatApi.useCloseChatMutation();
    const [updateChat] = ChatApi.useUpdateChatMutation();
    const [leaveChat] = ChatApi.useLeaveChatMutation();
    const [unpinChat] = ChatApi.useUnpinChatMutation();
    const { data: pins } = ChatApi.useGetPinnedChatsQuery(undefined, { skip: !profile?.Features.Chat });

    async function moreOptionsClick(e: MenuSelectEvent) {
        //End user leaving chat
        if (e.item.data === 4) {
            if (window.confirm('Are you sure you want to leave this Chat session')) {
                leaveChat(chat).unwrap().then(() => {
                    dispatch(LeaveChat(chat));
                });
            }
        }

        //Mark unread
        if (e.item.data === 2)
            dispatch(MarkAsRead({ conversationId: chat.ConversationId, contactId: profile.Id, unRead: true }))
        //Mark read
        if (e.item.data === 3)
            dispatch(MarkAsRead({ conversationId: chat.ConversationId, contactId: profile.Id, unRead: false }))
        //Mark read
        //if (e.item.data === 3)
        //  dispatch(MarkAsRead({ conversationId: chat.ConversationId, contactId: profile.Id, unRead: false }))


        //Close Chat
        if (e.item.data === 1) {
            if (window.confirm('Are you sure you want to permanently close this Chat?')) {
                await closeChat(chat).unwrap().then((res) => {
                    dispatch(CloseChat(chat));
                });
                //Unpin the chat if it is pinned
                if (pins.find(p => p.Chat_Id === chat.Id) !== null) {
                    await unpinChat(pins.find(p => p.Chat_Id === chat.Id)).unwrap();
                }
            }
        }


        setMenu(null);
    }
    const anchor = useRef();

    if (!profile) return <></>;


    return (
        <>
            <Button ref={anchor} title='More options' className='more-options' icon='more-horizontal' fillMode='flat'
                onBlur={(e) =>
                    setTimeout(() => {
                        setMenu((v) => { return { visible: false, offset: { top: 0, left: 0 } } as MenuProps });
                    }, 500)}
                onClick={(e) => setMenu((v) => {
                    //console.log(e.currentTarget.offsetLeft, e.currentTarget.offsetTop)
                    return { visible: !v?.visible, offset: { top: e.clientY + 30, left: e.clientX - 110 } } as MenuProps
                })}></Button >

            <Popup show={menu?.visible}
                offset={menu?.offset}
                // anchor={anchor.current}
                anchorAlign={{ horizontal: 'left', vertical: 'center' }} className='chat-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
                <Menu openOnClick={true} onSelect={moreOptionsClick} vertical={true}    >
                    {profile?.Features.Chat && !chat.IsClosed && (ChatIsUnRead(profile?.Uid, chat)
                        ? <MenuItem text='Mark as read' data={3} icon='eye' />
                        : <MenuItem text='Mark as unread' data={2} icon='eye' />)}
                    {profile?.Features.Chat && <MenuItem text='Full screen' data={0} icon='fullscreen' url={`./chat/${chat.ConversationId}`} />}
                    {profile?.Features.Chat && <MenuItem text={`Log ${profile.Phrases.CallPhrase}`} data={0} icon='login' url={`./ticket/fromchat/${chat.ConversationId}/`} />}
                    {profile?.Features.Chat && !chat?.IsClosed && <MenuItem text='Close Chat' data={1} icon='close-circle' />}
                    {/* End user option to leave chat */}
                    {profile?.Features.SSIChat && <MenuItem text='Leave Chat' data={4} icon='close-circle' />}
                </Menu>
            </Popup>
        </>
    )
}
